/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContributionOutputDto { 
    id?: number;
    message?: string | null;
    creationTime?: string;
    userId?: number;
    amount?: number;
    contributedBy?: string | null;
    loanId?: number;
    status?: string | null;
    transactionModeType?: string | null;
    paymentProviderName?: string | null;
    initiatedBy?: string | null;
    accountNumber?: string | null;
    balance?: number;
    transactionId?: string | null;
    productName?: string | null;
    externalRef?: string | null;
    comment?: string | null;
}

